import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAccount } from '~publish/contexts/AccountContext'

const FORCED_SETUP_PATH = '/setup-2fa-required'

/**
 * Publish-side counterpart to app-shell's `Enforce2FARedirect`. Reads from
 * publish's `useAccount()` — which refetches `GetAccount` on every
 * `ORGANIZATION_EVENT_KEY` event — so switching orgs from the navbar
 * reliably triggers a re-evaluation of the gate.
 *
 * App-shell's redirect runs from its own Apollo cache, which is shuffled
 * (not refetched) by `useOrgSwitcher`; that's enough for first load but
 * not for in-app org switches. This component is the belt to that
 * suspenders.
 */
export function Enforce2FARedirect(): null {
  const { account } = useAccount()
  const navigate = useNavigate()
  const location = useLocation()

  const shouldEnforce2FASetup = Boolean(
    account?.currentOrganization?.shouldEnforce2FASetup,
  )
  const isOnSetupPath = location.pathname.startsWith(FORCED_SETUP_PATH)

  useEffect(() => {
    if (!account?.id) return
    if (!shouldEnforce2FASetup) return
    if (isOnSetupPath) return
    navigate(FORCED_SETUP_PATH, { replace: true })
  }, [
    account?.id,
    account?.currentOrganization?.id,
    shouldEnforce2FASetup,
    isOnSetupPath,
    navigate,
  ])

  return null
}
